// Mock data for GPM Classics — a classic car dealership
// NOTE: All data here is MOCKED for the frontend teaser.

export const LOGO_URL =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_c3178930-b50b-41f7-96c7-0a33cbb500d8/artifacts/w1cdhpo2_dd9b5887-be1d-4646-b30a-b14ef62aeaf7.png";

export const HERO_IMAGES = [
  "https://images.unsplash.com/photo-1677440389473-32cf5e679891?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxjbGFzc2ljJTIwc3BvcnRzJTIwY2FyfGVufDB8fHx8MTc4NjU2NzAxNHww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1531274639088-8d2dd0c7b344?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHw0fHxjbGFzc2ljJTIwc3BvcnRzJTIwY2FyfGVufDB8fHx8MTc4NjU2NzAxNHww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1579211897956-297c1150469a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHx2aW50YWdlJTIwY2FyfGVufDB8fHx8MTc4NjU2NzAxM3ww&ixlib=rb-4.1.0&q=85",
];

export const RACING_IMAGES = [
  "https://images.unsplash.com/photo-1618102190111-ea612116fd8f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxjbGFzc2ljJTIwcmFjZSUyMGNhcnxlbnwwfHx8fDE3ODc2NTk2MzN8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1585897685768-409600fec957?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxjbGFzc2ljJTIwcmFjZSUyMGNhcnxlbnwwfHx8fDE3ODc2NTk2MzN8MA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/16461387/pexels-photo-16461387.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1728569781606-23c1b4fb5f48?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHx2aW50YWdlJTIwcmFjaW5nfGVufDB8fHx8MTc4NzY1OTYzM3ww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1730158844260-2bda8f07a8fb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHx2aW50YWdlJTIwcmFjaW5nfGVufDB8fHx8MTc4NzY1OTYzM3ww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1560692830-04adc2f31119?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwzfHxtb3RvcnNwb3J0fGVufDB8fHx8MTc4NzY1OTYzM3ww&ixlib=rb-4.1.0&q=85",
];

const IMG = {
  camaroWhite:
    "https://images.unsplash.com/photo-1591293835940-934a7c4f2d9b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHw0fHxjbGFzc2ljJTIwY2FyfGVufDB8fHx8MTc4NjU2NzAzOXww&ixlib=rb-4.1.0&q=85",
  camaroBlack:
    "https://images.unsplash.com/photo-1587750059638-e7e8c43b99fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxjbGFzc2ljJTIwY2FyfGVufDB8fHx8MTc4NjU2NzAzOXww&ixlib=rb-4.1.0&q=85",
  camaroRed:
    "https://images.unsplash.com/photo-1584345604325-f5091269a0d1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwzfHxjbGFzc2ljJTIwY2FyfGVufDB8fHx8MTc4NjU2NzAzOXww&ixlib=rb-4.1.0&q=85",
  mustangRed:
    "https://images.unsplash.com/photo-1579211897956-297c1150469a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHx2aW50YWdlJTIwYXV0b21vYmlsZXxlbnwwfHx8fDE3ODY1NjcwNDB8MA&ixlib=rb-4.1.0&q=85",
  mustangPink:
    "https://images.unsplash.com/photo-1544896478-d5b709d413c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHx2aW50YWdlJTIwYXV0b21vYmlsZXxlbnwwfHx8fDE3ODY1NjcwNDB8MA&ixlib=rb-4.1.0&q=85",
  sedanChrome:
    "https://images.unsplash.com/photo-1579211897986-63e1fcd564e0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHx2aW50YWdlJTIwYXV0b21vYmlsZXxlbnwwfHx8fDE3ODY1NjcwNDB8MA&ixlib=rb-4.1.0&q=85",
  tealSedan:
    "https://images.unsplash.com/photo-1603039548092-fff996c2441c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxyZXRybyUyMGNhcnxlbnwwfHx8fDE3ODY1NjcwNTB8MA&ixlib=rb-4.1.0&q=85",
  retroCar:
    "https://images.unsplash.com/photo-1484687742385-1249620c2687?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxyZXRybyUyMGNhcnxlbnwwfHx8fDE3ODY1NjcwNTB8MA&ixlib=rb-4.1.0&q=85",
};

export const CARS = [
  {
    id: "1",
    slug: "mercedes-350-sl-sports-auto",
    title: "Mercedes 350 SL Sports Auto",
    price: 24995,
    priceLabel: "£24,995",
    status: "available",
    year: 1973,
    mileage: "78,400",
    transmission: "Automatic",
    fuel: "Petrol",
    engine: "3.5L V8",
    colour: "Silver Blue",
    images: [IMG.camaroWhite, IMG.sedanChrome, IMG.tealSedan],
    short: "A beautifully preserved R107 roadster with hard & soft tops.",
    description:
      "This stunning Mercedes 350 SL is a superb example of the iconic R107 roadster. Presented in Silver Blue with a contrasting interior, this car has been meticulously maintained and comes complete with both the removable hard top and folding soft top. A true modern classic that drives as good as it looks.",
  },
  {
    id: "2",
    slug: "aston-martin-vanquish-s",
    title: "Aston Martin Vanquish S",
    price: null,
    priceLabel: "POA",
    status: "hold",
    year: 2005,
    mileage: "41,200",
    transmission: "Automated Manual",
    fuel: "Petrol",
    engine: "5.9L V12",
    colour: "British Racing Green",
    images: [IMG.camaroBlack, IMG.sedanChrome, IMG.camaroRed],
    short: "The definitive Aston GT — a 5.9 litre V12 grand tourer.",
    description:
      "An exceptional Aston Martin Vanquish S finished in classic British Racing Green over a tan hide interior. Powered by the legendary 5.9 litre V12, this hand-built grand tourer delivers effortless performance with unmistakable presence. Full service history and a comprehensive tool kit accompany this magnificent motorcar.",
  },
  {
    id: "3",
    slug: "chevrolet-camaro-z28-manual",
    title: "Chevrolet Camaro Z28 Manual",
    price: 46995,
    priceLabel: "£46,995",
    status: "available",
    year: 1969,
    mileage: "62,000",
    transmission: "Manual",
    fuel: "Petrol",
    engine: "5.7L V8",
    colour: "Hugger Orange",
    images: [IMG.camaroRed, IMG.camaroWhite, IMG.camaroBlack],
    short: "An icon of American muscle — the sought-after Z28 manual.",
    description:
      "A genuine Chevrolet Camaro Z28 with a rumbling 5.7 litre V8 mated to a four-speed manual gearbox. This muscle car has been the subject of a sympathetic restoration and presents beautifully throughout. A rare opportunity to own a piece of American automotive history.",
  },
  {
    id: "4",
    slug: "austin-mini-cooper-s-mk-i",
    title: "Austin Mini Cooper S Mk I 1275cc",
    price: 32995,
    priceLabel: "£32,995",
    status: "available",
    year: 1966,
    mileage: "54,300",
    transmission: "Manual",
    fuel: "Petrol",
    engine: "1275cc",
    colour: "Almond Green / White Roof",
    images: [IMG.retroCar, IMG.tealSedan, IMG.sedanChrome],
    short: "A concours Mk I Cooper S in classic Almond Green.",
    description:
      "This Austin Mini Cooper S Mk I is a wonderful example of Britain's most beloved small car. Finished in Almond Green with a contrasting Old English White roof, the 1275cc engine gives this pocket rocket a thrilling turn of speed. Extensive history file and heritage certificate included.",
  },
  {
    id: "5",
    slug: "jaguar-e-type-v12-roadster",
    title: "Jaguar E-Type V12 Roadster",
    price: 79995,
    priceLabel: "£79,995",
    status: "available",
    year: 1973,
    mileage: "48,900",
    transmission: "Manual",
    fuel: "Petrol",
    engine: "5.3L V12",
    colour: "Carmen Red",
    images: [IMG.mustangRed, IMG.camaroRed, IMG.sedanChrome],
    short: "Series 3 V12 roadster — described by Enzo as the most beautiful.",
    description:
      "Arguably the most beautiful car ever made, this Jaguar E-Type Series 3 V12 Roadster is presented in Carmen Red over black leather. The silky smooth 5.3 litre V12 provides effortless grand touring performance. Restored to an exacting standard and ready to enjoy.",
  },
  {
    id: "6",
    slug: "bmw-320i-convertible-e30",
    title: "BMW 320i Convertible (E30)",
    price: 24995,
    priceLabel: "£24,995",
    status: "available",
    year: 1990,
    mileage: "89,000",
    transmission: "Manual",
    fuel: "Petrol",
    engine: "2.0L Inline-6",
    colour: "Alpine White",
    images: [IMG.sedanChrome, IMG.tealSedan, IMG.retroCar],
    short: "The definitive 80s cabriolet — a sweet-revving straight six.",
    description:
      "A superb BMW 320i Convertible (E30) finished in Alpine White with a blue interior. The smooth 2.0 litre straight-six is a joy on the open road with the roof down. A genuinely appreciating modern classic in lovely order throughout.",
  },
  {
    id: "7",
    slug: "bmw-325i-convertible-e30",
    title: "BMW 325i Convertible (E30)",
    price: 24995,
    priceLabel: "£24,995",
    status: "available",
    year: 1991,
    mileage: "76,500",
    transmission: "Automatic",
    fuel: "Petrol",
    engine: "2.5L Inline-6",
    colour: "Diamond Black",
    images: [IMG.camaroBlack, IMG.sedanChrome, IMG.tealSedan],
    short: "The flagship E30 cabriolet with the punchy 2.5 six.",
    description:
      "This BMW 325i Convertible (E30) is presented in Diamond Black metallic with a grey leather interior. The torquey 2.5 litre straight-six makes for relaxed cruising. Well documented with a comprehensive history file and recent service.",
  },
  {
    id: "8",
    slug: "mini-convertible-jcw",
    title: "Mini Convertible Auto JCW VAT Qualifying",
    price: null,
    priceLabel: "POA",
    status: "available",
    year: 2016,
    mileage: "22,100",
    transmission: "Automatic",
    fuel: "Petrol",
    engine: "2.0L Turbo",
    colour: "Chili Red",
    images: [IMG.mustangRed, IMG.retroCar, IMG.camaroRed],
    short: "A modern JCW cabriolet — VAT qualifying with full spec.",
    description:
      "A modern classic in the making, this Mini Convertible John Cooper Works is finished in Chili Red with a full JCW specification. VAT qualifying and with low mileage, this hot Mini offers thrilling performance and everyday usability in equal measure.",
  },
];

export const SOLD_CARS = [
  {
    id: "s1",
    title: "Ferrari 365 GTB/4 Daytona",
    priceLabel: "SOLD",
    year: 1972,
    image: IMG.camaroBlack,
  },
  {
    id: "s2",
    title: "Porsche 911 Carrera 3.2",
    priceLabel: "SOLD",
    year: 1987,
    image: IMG.tealSedan,
  },
  {
    id: "s3",
    title: "MGB Roadster",
    priceLabel: "SOLD",
    year: 1969,
    image: IMG.retroCar,
  },
  {
    id: "s4",
    title: "Ford Mustang Fastback",
    priceLabel: "SOLD",
    year: 1966,
    image: IMG.mustangRed,
  },
  {
    id: "s5",
    title: "Triumph TR6",
    priceLabel: "SOLD",
    year: 1974,
    image: IMG.camaroRed,
  },
  {
    id: "s6",
    title: "Jaguar XK150 Drophead",
    priceLabel: "SOLD",
    year: 1959,
    image: IMG.sedanChrome,
  },
];

export const COMPANY = {
  name: "GPM Classics",
  phone: "07785 355378",
  email: "info@gpmclassics.com",
  address: "Based in Devon, UK",
  facebook: "https://www.facebook.com/profile.php?id=61593951423457",
  instagram: "https://www.instagram.com/gpmclassics",
};

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "Cars For Sale", path: "/cars-for-sale" },
  { label: "Motorcycles For Sale", path: "/motorcycles" },
  { label: "Racing", path: "/racing" },
  { label: "Our Services", path: "/services" },
  { label: "Sold", path: "/sold" },
  { label: "Car Sourcing", path: "/car-sourcing" },
  { label: "Contact Us", path: "/contact" },
];
